module.exports = __webpack_public_path__ + "static/media/logo.769709f4.png";